module.exports = __webpack_public_path__ + "media/images/version_merge/google_play_btn-815225678b06a202f2414fde034c4431.svg";